import { FormControl } from "@angular/forms";

export interface PurchaseItem {
    licenseType: string;
    quantity: number;
    licenseName: string;
    price: string;
    total: number;
};

export interface PurchaseItemForm {
    licenseType: FormControl<string>;
    quantity: FormControl<number>;
};